import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSigma = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "#363636",
		d: "M12 0.5H2L8 6.5L2 12.5H12"
	})
});
export default SvgSigma;
